import PrinterSettings from './PrinterSettings';

export default PrinterSettings;
